import { initialDocumentType } from './initialState';
import * as types from '../actions/actionTypes';
import { IDocumentType, ImanageDocumentTypeReducer } from '../models';
import { pickBy, map, keyBy } from 'lodash';
import {
    createSelectedIDWithName,
    modalToggleWithName
} from './commonReducers';
import { combineReducers } from 'redux';
import { IinitialState } from '.';

export const documentTypeSelector = (state: IinitialState) =>
    state.manageDocumentType.documentTypesByID;

export function documentTypesByID(
    state: { [key: string]: IDocumentType } = {},
    action: any
): { [key: string]: IDocumentType } {
    switch (action.type) {
        case types.LOAD_DOCUMENT_TYPES_SUCCESS: {
            const newDocumentTypes = map(action.payload, type => {
                return {
                    ...initialDocumentType,
                    ...pickBy(type, (property, key) => property !== null)
                };
            }) as IDocumentType[];
            return { ...state, ...keyBy(newDocumentTypes, 'id') };
        }
        case types.ADD_DOCUMENT_TYPES_SUCCESS:
            return { ...state, [action.payload.id]: action.payload };
        case types.EDIT_DOCUMENT_TYPE_SUCCESS:
            return {
                ...state,
                [action.payload.value.id]: action.payload.value
            };
        case types.DELETE_DOCUMENT_TYPE_SUCCESS: {
            const data = { ...state };
            delete data[action.payload];
            return data;
        }
        default:
            return state;
    }
}

const documentTypeManage = combineReducers<ImanageDocumentTypeReducer>({
    documentTypesByID,
    selectedDocumentTypeID: (state, action) =>
        createSelectedIDWithName(state, action, 'DOCUMENT_TYPE_ID'),
    showEditDocumentTypeModal: (state, action) =>
        modalToggleWithName(state, action, 'EDIT_DOCUMENT_TYPE')
});

export default documentTypeManage;
